import {addComponentKeysets} from '../../../../i18n';

import en from './en.json';
import ru from './ru.json';

const COMPONENT = 'PasswordInput';

export const i18n = addComponentKeysets({en, ru}, COMPONENT);
